import React, { useState } from 'react';

const ExpandableText = ({ text, maxLength = 200, className = '' }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  // Return original text if it's short enough
  if (!text || text.length <= maxLength) {
    return <span className={className}>{text}</span>;
  }
  
  // Find a good break point (end of sentence or word)
  const findBreakPoint = (str, max) => {
    // Try to break at a sentence
    const sentenceEnd = str.lastIndexOf('. ', max);
    if (sentenceEnd > max * 0.6) return sentenceEnd + 1;
    
    // Try to break at a semicolon
    const semicolon = str.lastIndexOf('; ', max);
    if (semicolon > max * 0.6) return semicolon + 1;
    
    // Break at last space
    const lastSpace = str.lastIndexOf(' ', max);
    if (lastSpace > max * 0.5) return lastSpace;
    
    return max;
  };
  
  const breakPoint = findBreakPoint(text, maxLength);
  const truncatedText = text.substring(0, breakPoint);
  const remainingText = text.substring(breakPoint);
  
  return (
    <span className={className}>
      {isExpanded ? (
        <>
          {text}
          <button
            onClick={() => setIsExpanded(false)}
            style={{
              marginLeft: '8px',
              padding: '2px 8px',
              backgroundColor: 'transparent',
              color: '#4285f4',
              border: 'none',
              borderRadius: '4px',
              fontSize: '12px',
              cursor: 'pointer',
              fontWeight: '500',
              transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#f0f7ff'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            See less
          </button>
        </>
      ) : (
        <>
          {truncatedText}
          {!truncatedText.endsWith('.') && '...'}
          <button
            onClick={() => setIsExpanded(true)}
            style={{
              marginLeft: '8px',
              padding: '2px 8px',
              backgroundColor: 'transparent',
              color: '#4285f4',
              border: 'none',
              borderRadius: '4px',
              fontSize: '12px',
              cursor: 'pointer',
              fontWeight: '500',
              transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#f0f7ff'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            See more
          </button>
        </>
      )}
    </span>
  );
};

export default ExpandableText;